import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { RequestParams, ResponseCatalog } from 'Models'
import { BlackListPartnerModel } from 'Pages/pp'
import { serialize } from 'object-to-formdata'

export const blackListPartnerApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<BlackListPartnerModel>>(
			urls.blackListPartner.index,
			{ params }
		)
		return res.data
	},
	getOne: async (id: string) => {
		const res = await axiosDS().get<BlackListPartnerModel>(`${urls.blackListPartner.index}/${id}`)
		return res.data
	},
	createOne: async (data: Omit<BlackListPartnerModel, 'id'>) => {
		const res = await axiosDS().post<BlackListPartnerModel>(urls.blackListPartner.index, { data })
		return res.data
	},
	updateOne: async (id: string, data: BlackListPartnerModel) => {
		const res = await axiosDS().patch<BlackListPartnerModel>(
			`${urls.blackListPartner.index}/${id}`,
			{
				data,
			}
		)
		return res.data
	},
	deleteOne: async (id: string) => {
		const res = await axiosDS().delete<BlackListPartnerModel>(
			`${urls.blackListPartner.index}/${id}`
		)
		return res.data
	},
	createMass: async (data: { file: File }) => {
		const res = await axiosDS().post<BlackListPartnerModel>(
			urls.blackListPartner.mass_create,
			serialize({ data }, { allowEmptyArrays: true })
		)
		return res.data
	},
}
